@if (!selectedContrat) {
  <div class="list-contrat-container">
    <div class="flex-horizontal gap-16">
      <app-search-investisseur-autocomplete
        class="flex-1"
        (onInvestisseurIdSelected)="onInvestisseurIdSelected($event)"
      [isClientStatutOnly]="false"></app-search-investisseur-autocomplete>
      <app-search-enveloppe-produit-autocomplete
        (onEnveloppeSelect)="onEnveloppeIdSelected($event)"
        (onProduitSelect)="onProduitSelected($event)"
        [useSpinner]="false"
      class="flex-horizontal gap-16 flex-1 width-100pc"></app-search-enveloppe-produit-autocomplete>
    </div>
    <div class="table">
      <app-contrats-table
        [receivedData]="requestResult"
        (requestNewPage)="getAllCommandes()"
        (onRowClicked)="onContratClick($event)"
        [(paginationParams)]="paginationParams"
      [withLoadingOnPageChange]="true"></app-contrats-table>
    </div>
  </div>
}
@if (selectedContrat) {
  <div class="selected-contrat-container">
    <div class="selected-contrat-header">
      @if (selectedContrat) {
        <div class="body-2">Contrat sélectionné :</div>
      }
      @if (!isModifierDisabled) {
        <a (click)="onModifier()">Modifier</a>
      }
      @if (isModifierDisabled) {
        <div [ouiTooltip]="toolTipText" [ouiTooltipPosition]="toolTipPosition">
          <a class="link-disabled">Modifier</a>
        </div>
      }
    </div>
    <div class="selected-contrat-body">
      <oui-table>
        <table class="padding-16 with-border mingap">
          <tr>
            <td>{{ selectedInvestisseurFullName }}</td>
            @if (selectedCoInvestisseurFullName) {
              <td>
                {{ selectedCoInvestisseurFullName }}
              </td>
            }
            <td>
              <div class="flex-vertical">
                <div class="body-2 color-on-surface-emphasis">
                  N° {{ selectedContrat.numeroContrat ?? 'non renseigné' }}
                </div>
                <div class="caption color-on-surface-medium">
                  {{
                  selectedContrat.dateActe
                  ? 'le ' + (selectedContrat.dateActe | date : 'dd-MM-yyyy')
                  : 'date non renseignée'
                  }}
                </div>
              </div>
            </td>
            <td>{{ selectedContrat.produit.enveloppeNavigation?.libelle }}</td>
            <td>
              <div class="flex-vertical">
                <div class="body-2 color-on-surface-emphasis">
                  {{ selectedContrat.produit.nomTechniqueProduitBox ?? selectedContrat.produit.nom }}
                </div>
                <div class="caption color-on-surface-medium">
                  {{ $safeNavigationMigration(selectedContrat.produit.idPartenaireNavigation?.nom) | uppercase }}
                </div>
              </div>
            </td>
            <td>
              @if (selectedContrat?.prixVenteTotalTTC) {
                <div>
                  {{ selectedContrat.prixVenteTotalTTC | currency : 'EUR' : '€' }}
                </div>
              }
              @if (!selectedContrat?.prixVenteTotalTTC) {
                <div>non renseigné</div>
              }
            </td>
          </tr>
        </table>
      </oui-table>
      @if(!draftOperationsService.isActeDeGestionNoBox){ @if(isHabilitationValid){
        <oui-banner
          title="Après cette étape vous ne pourrez plus changer le contrat sélectionné."
        [showCloseButton]="false"></oui-banner>
      } @else {
        <oui-banner
          declination="error"
          title="Votre habilitation pour le produit associé à ce contrat est inactive, vous ne pouvez pas déclarer d’acte de gestion."
        [showCloseButton]="false"></oui-banner>
        } } @else {
        <oui-banner
          declination="error"
          title="La déclaration sur la Box Placement de cette opération n'est pas à effectuer, vous devez simplement traiter directement l'opération avec le partenaire dans ce cas précis."
          [showCloseButton]="false"></oui-banner
          >}
        </div>
      </div>
    }
